import { Component, ViewEncapsulation } from '@angular/core';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import { RtPipe } from '@usheru-hff/ui/pipes';

@Component({
  selector: 'ush-load-more-cinemas',
  template: `
    <button class="load-more-cinemas__button">
      <span class="load-more-icon">+</span>
      <span data-translate="button.load-more-cinemas" i18n="@@button.load-more-cinemas">
        {{ 'button.load-more-cinemas' | rt: 'Load more cinemas' }}
      </span>
    </button>
  `,
  styles: `
    .load-more-cinemas__button {
      position: relative;
      cursor: pointer;
      margin: 20px auto;
      border: none;
      background: transparent;
      width: max-content;
      font-weight: var(--load-more-font-weight, bold);
      font-size: var(--load-more-font-size, 20px);
      font-family: inherit;
      text-transform: var(--load-more-text-transform, initial);
      span {
        color: var(--componentInCinemas-nearestCity-headerTextColor, var(--textColor));
      }
      &:hover,
      &:focus,
      &:active {
        span {
          text-decoration: underline;
          text-decoration-color: var(--load-more-underline-color, var(--brandColor));
          text-decoration-thickness: 2px;
          text-underline-offset: 0.3em;
        }
        span.load-more-icon {
          text-decoration: none !important;
        }
      }
      .load-more-icon {
        position: absolute;
        top: 0;
        left: -15px;
        margin-right: 10px;
        color: var(--load-more-icon-color, var(--brandColor));
      }
    }
  `,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [RtPipe]
})
export class LoadMoreCinemasComponent {
  faPlusIcon = faPlus;

  constructor() {}

  loadMore() {}
}
